'use client'

import React from 'react'

import ProjectFilters from '@/components/ProjectFilters'
import ProjectThumb from '@/components/ProjectThumb'

import { usePathname, useSearchParams } from 'next/navigation'

import { FC, useState, useEffect, Suspense } from 'react'

interface WorkLayoutThumbsProps {
	data: any
}

const WorkLayoutThumbs: FC<WorkLayoutThumbsProps> = ({ data }) => {
	const [activeFilter, setActiveFilter] = useState('')
	const thumbClass = 'work-grid-thumb'

	const searchParams = useSearchParams()
	const pathname = usePathname()
	const filter = searchParams.get('filter')

	useEffect(() => {
		// Get first thumb element that has prop data-active="true"
		const firstVisibleThumb = document.querySelector(`.${thumbClass}[data-active="true"]`)
		// Get the first thumb element
		const firstThumb = document.querySelector(`.${thumbClass}`)
		// Get top position of the first thumb element
		const thumbTop = firstThumb?.getBoundingClientRect().top
		// Get top position of the first visible thumb element
		const firstVisibleThumbTop = firstVisibleThumb?.getBoundingClientRect().top
		// Determine if on first row
		const isFirstRow = thumbTop === firstVisibleThumbTop
		// Scroll to the top of the first visible thumb
		if (firstVisibleThumb && !isFirstRow) {
			firstVisibleThumb.scrollIntoView()
		}
	}, [filter])
	return (
		<>
			<ProjectFilters
				disciplines={data?.disciplines}
				filter={filter}
				pathname={pathname}
				setActiveFilter={setActiveFilter}
			/>

			<div className="px-site-margin">
				<div className="flex flex-wrap items-start justify-between gap-x-gutter gap-y-[3rem] md:gap-y-[8rem]">
					{data?.projects?.projects?.map((item: any) => (
						<ProjectThumb
							key={`item-${item.project.slug.current}`}
							item={item}
							filter={filter}
							thumbClass={thumbClass}
						/>
					))}
				</div>
			</div>
		</>
	)
}

export default WorkLayoutThumbs
